// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2socm6","textContainer":"_1xvCJ5","closeIcon":"_2M2RHH","shine-lines":"_3b5ZJ7"};